import { render, staticRenderFns } from "./event-history.vue?vue&type=template&id=76152b44&scoped=true"
import script from "./event-history.ts?vue&type=script&lang=js&external"
export * from "./event-history.ts?vue&type=script&lang=js&external"
import style0 from "./event-history.less?vue&type=style&index=0&id=76152b44&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76152b44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76152b44')) {
      api.createRecord('76152b44', component.options)
    } else {
      api.reload('76152b44', component.options)
    }
    module.hot.accept("./event-history.vue?vue&type=template&id=76152b44&scoped=true", function () {
      api.rerender('76152b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event/event-history/event-history.vue"
export default component.exports